export default {
  name: 'Username',
  edit: {
    form: 'username',
    label: 'Change Username',
    handler: value => value,
  },
};
